// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"145":"31bf3814","220":"f1ba6aa5","263":"8b2b4755","738":"495d6a71","786":"31f2ff06"}[chunkId] + ".css";
};